/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { VALUATION_DATES_API } from 'services/constants';
import { ValuationDatesResponse } from 'services/types';
import { isApiFetchingCompletedAction } from '../utils';

const isValuationApiFullfilledAction =
  isApiFetchingCompletedAction(VALUATION_DATES_API);

export interface ValuationDatesState {
  selectedValuationDate: string;
  valuationDates: string[] | undefined;
}

const initialState: ValuationDatesState = {
  valuationDates: undefined,
  selectedValuationDate: new Date().toDateString(),
};

export const valuationDatesSlice: Slice<ValuationDatesState> = createSlice({
  name: 'valuationDatesSlice',
  initialState,
  reducers: {
    updateSelectedValuationDate: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedValuationDate: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isValuationApiFullfilledAction,
      (state, action: PayloadAction<ValuationDatesResponse[]>) => {
        const { payload } = action;
        state.selectedValuationDate =
          payload && payload.length > 0
            ? payload[payload.length - 1]?.valuation_date
            : Date.now.toString();
        state.valuationDates = payload.map((date) => date.valuation_date);
      }
    );
  },
});

export const { updateSelectedValuationDate } = valuationDatesSlice.actions;
